import { render, staticRenderFns } from "./CatalogForm.vue?vue&type=template&id=6339d12a&"
import script from "./CatalogForm.ts?vue&type=script&lang=ts&"
export * from "./CatalogForm.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports